import { OnInit, Component } from "@angular/core";

import { SamlAliasEditComponent } from "app/administrative/saml-aliases/saml-alias-wizard/saml-alias-edit/saml-alias-edit.component";
import { PolicyAccessSelectComponent } from "../policy-access-select/policy-access-select.component";

/**
 * This class extends the  SamlAliasEditComponent and customizes it's behavior slightly to embed it in the policy wizard.
 * We want to use the same html template, but must provide a relative path from _this_ location to that file
 */
@Component({
	templateUrl: "../../../saml-aliases/saml-alias-wizard/saml-alias-edit/saml-alias-edit.component.html"
})
export class SamlAliasCreateComponent extends SamlAliasEditComponent implements OnInit {

	public async ngOnInit() {
		this.service.newSamlAlias();
		await super.ngOnInit();
	}

	public get nextStep() {
		return PolicyAccessSelectComponent;
	}

	public get previousStep() {
		return PolicyAccessSelectComponent;
	}

	public get isFormValid() {
		return this.form && this.form.valid;
	}

	public async performPrevious() {
		// noop
	}

	public async performNext() {
		if (this.form.valid) {
			await super.saveSamlAlias();
		}
	}

}
